import type { IconData } from '@stacksjs/iconify-core'

export const userProtectionCheck: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M26.195 29.58c.146-1.652 1.173-2.97 2.815-3.202C30.448 26.175 32.656 26 36 26s5.552.175 6.99.378c1.642.232 2.67 1.55 2.814 3.202A51 51 0 0 1 46 34c0 4.514-2.383 8.738-6.396 10.804C38.263 45.494 36.954 46 36 46s-2.263-.506-3.604-1.196C28.382 42.738 26 38.514 26 34c0-1.708.091-3.233.195-4.42\"/><path d=\"m32.5 34.767l3.294 3.733l4.706-7m-17.553-7.673A11 11 0 0 0 29 14c0-6.075-4.925-11-11-11S7 7.925 7 14a11 11 0 0 0 6.053 9.827c-5.017 1.736-8.818 6.038-9.803 11.319c-.318 1.706.675 3.1 2.397 3.323C7.742 38.74 11.457 39 18 39q1.611 0 3-.02\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userProtectionCheck
